import React, { Component } from "react"
import { InputCustom, SelectWithSearch, HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import { LoadModal } from "../modais"
export default class RelatorioConsumoForm extends Component {
  constructor() {
    super()
    this.onChangeDataInicio = this.onChangeDataInicio.bind(this)
    this.onChangeDataFinal = this.onChangeDataFinal.bind(this)
    this.onChangeContrato = this.onChangeContrato.bind(this)
    this.getContratos = this.getContratos.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      dataDeInicio: "",
      dataFinal: "",
      contrato: "",
      contratos: [],
      formError: ""
    }
  }
  componentWillMount() {
    this.getContratos()
  }
  getContratos() {
    ApiHelper.getAllContratos((contratos, error) => {
      if (contratos) {
        var mapped = Util.mapContratos(contratos)
        mapped.shift()
        this.setState({
          contratos: mapped
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  onChangeContrato(event) {
    this.setState({
      contrato: event
    })
  }
  onChangeDataInicio(value) {
    var newValue = value
    this.setState({
      dataDeInicio: newValue
    })
  }
  onChangeDataFinal(value) {
    var newValue = value
    this.setState({
      dataFinal: newValue
    })
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      tipo_relatorio: "Consumo",
      contrato_id:
        this.state.contrato === undefined || this.state.contrato === null
          ? null
          : this.state.contrato.value,
      start_date: Util.dateOnly(this.state.dataDeInicio),
      end_date: Util.dateOnly(this.state.dataFinal)
    }
    this.toggleLoadModal()
    ApiHelper.getRelatorioWith(params, relatorio => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Relatório de consumo.pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.setState({
          formError: "Não existem baixas nesse período"
        })
      }
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="row card" style={{ marginTop: 100 }}>
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="card card-content">
        <div className="row ">
          <LoadModal
            onClose={this.toggleLoadModal}
            show={this.state.showLoad}
          />
          <SelectWithSearch
            error={this.state.formError}
            sizeClass="col-md-8"
            options={this.state.contratos}
            label="Contrato"
            placeholder="Selecione um contrato ou deixe em branco para selecionar todos"
            onChange={this.onChangeContrato}
            value={this.state.contrato}
          />
        </div>
        <div className="row">
          <InputCustom
            sizeClass="col-md-3"
            type="date"
            label="Data inicial"
            onChange={this.onChangeDataInicio}
            value={this.state.dataDeInicio}
          />
          <InputCustom
            sizeClass="col-md-3"
            type="date"
            label="Data final"
            onChange={this.onChangeDataFinal}
            value={this.state.dataFinal}
          />
        </div>
        <div className="row">
          <button
            onClick={this.sendForm}
            type="submit"
            className="btn btn-primary pull-left"
            data-background-color="as-blue"
          >
            Gerar
          </button>
        </div>
        <span className="label label-primary">
          PS:Se as datas forem deixadas em branco, todo o período de vigência
          será contemplado
        </span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/relatorios/RelatorioConsumoForm.js